const ValorantIcon = () => {
  return (
    <path
      xmlns='https://www.w3.org/2000/svg'
      d='M1.756 5.345C1.482 5.029 1.042 4.915.65 5.063.259 5.209 0 5.583 0 6v7c0 .242.088.477.248.658l7 8C7.438 21.876 7.711 22 8 22h6c.392 0 .747-.229.91-.585.163-.355.103-.774-.154-1.07L1.756 5.345zM23.325 6.054c-.404-.138-.852-.005-1.114.332l-7 9c-.234.302-.276.711-.109 1.054C15.27 16.782 15.618 17 16 17h5c.334 0 .646-.167.832-.445l2-3C23.941 13.391 24 13.197 24 13V7C24 6.573 23.729 6.192 23.325 6.054z'
    />
  );
};

export default ValorantIcon;
